import React, { useEffect, useMemo, useState } from "react"
import Modal from "react-bootstrap/Modal"
import Form from "react-bootstrap/Form"
import Spinner from "react-bootstrap/Spinner"
import Button from "../common/Button.jsx"

/**
 * @param {{
 *   show: boolean,
 *   order: any,
 *   onClose: () => void,
 *   onConfirm: (staffInitial: string) => Promise<void> | void,
 *   isDeleting?: boolean,
 * }} props
 */
export default function DeleteOrderModal({
    show,
    order,
    onClose,
    onConfirm,
    isDeleting = false,
}) {
    const [staffInitial, setStaffInitial] = useState("")

    const masterLabel = useMemo(
        () => (order?.master != null ? `#${order.master}` : "#?"),
        [order?.master]
    )

    useEffect(() => {
        if (!show) {
            setStaffInitial("")
        }
    }, [show])

    async function handleDelete() {
        const si = staffInitial.trim()
        if (!si || isDeleting) return
        await onConfirm(si)
    }

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Delete Order</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="text-secondary mb-3">
                    Order {masterLabel} will be permanently deleted. This cannot be undone.
                </div>
                <Form.Group className="d-flex align-items-end">
                    <Form.Label className="mb-0">
                        Staff Initial<span className="text-danger ms-1">*</span>
                    </Form.Label>
                    <Form.Control
                        className="ms-3"
                        value={staffInitial}
                        onChange={(e) => setStaffInitial(e.currentTarget.value)}
                        style={{ width: "100px" }}
                        disabled={isDeleting}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline" onClick={onClose} disabled={isDeleting}>
                    Cancel
                </Button>
                <Button
                    variant="danger"
                    onClick={handleDelete}
                    disabled={isDeleting || !staffInitial.trim()}
                >
                    {isDeleting ? (
                        <span className="d-inline-flex align-items-center">
                            <Spinner animation="border" size="sm" className="me-2" />
                            Delete Forever
                        </span>
                    ) : (
                        "Delete Forever"
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

